import { lazy } from 'react';

const Slider = lazy(() => import('./Slider'));

export { Slider };
